/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {MaterialMoreVertIcon} from '../../icons/MaterialMoreVertIcon';
import Tooltip from '../tooltip/Tooltip';
import {IconButton} from './IconButton';

export const ActionTooltip = (props: MoreActionTooltipProps) => (
  <Tooltip arrow {...props} />
);

export type MoreActionTooltipProps = {
  title: string;
  children: React.ReactElement<any, any>;
};

// defines the container props ...
export type MoreActionButtonProps = {
  onAction: (params?: boolean) => void,
  hideTitle?: boolean
};

/**
 * The MoreActionButton provides the More Action Button
 *
 * ```typescript
 *   import {MoreActionButton} from '@ion/dls/src/components/buttons/MoreActionButton';
 *
 *   <MoreActionButton onAction={onAction} />
 * ```
 */
export const MoreActionButton = ({onAction, hideTitle = false}: MoreActionButtonProps) => (
  <ActionTooltip title={!hideTitle ? translate('common:actions') : ''}>
    <div>
      <IconButton icon={<MaterialMoreVertIcon />} onClick={onAction} />
    </div>
  </ActionTooltip>
);

export default MoreActionButton;
